// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"e95bd445","488":"adee5ca0"}[chunkId] + ".chunk.js");